export const namespace = 'bmap';

export const getters = {};

export const actions = {
  loadAk: 'loadAk',
  loadBMap: 'loadBMap',
};

export const mutations = {
  setAk: 'setAk',
};
